<template>
  <div
    class="bg-bg-base-bg2"
    data-test="contact-list-item-letter"
    :class="{'text-white!': darkTheme}"
  >
    <p class="text-body-r-15-22 text-fg-base-fg14 px-2">
      {{ letter }}
    </p>
  </div>
</template>

<script setup lang="ts">
defineProps({
  letter: {
    type: String,
    required: true,
  },
  darkTheme: {
    type: Boolean,
    default: false,
  },
})
</script>
